import { render, staticRenderFns } from "./calWeek.vue?vue&type=template&id=58fbc731&scoped=true"
import script from "./calWeek.vue?vue&type=script&lang=js"
export * from "./calWeek.vue?vue&type=script&lang=js"
import style0 from "./calWeek.vue?vue&type=style&index=0&id=58fbc731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbc731",
  null
  
)

export default component.exports